module.exports = __webpack_public_path__ + "static/media/WQU_logo_color.70b2e8e1.png";